module.exports = __webpack_public_path__ + "application/directives/svg-image/excel-svg/excel-svg.template.html";